var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFestival1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-festival1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 11a33.523 33.523 0 0 0 1.735-.389l2.456 2.77.767-3.747c.2-.072.351-.13.452-.17l-.372-.928c-.148.06-.434.166-.836.304-.673.23-1.423.461-2.232.677-2.305.615-4.608.983-6.746.983-2.138 0-4.441-.368-6.746-.983a33.649 33.649 0 0 1-2.232-.677 19.447 19.447 0 0 1-.836-.304l-.372.928c.082.033.197.077.343.13l.775 3.787 2.475-2.79c.359.09.718.176 1.076.255l1.711 4.33 2.293-3.731a21.313 21.313 0 0 0 2.367.037l2.27 3.696L15.777 11zm0-8a33.524 33.524 0 0 0 1.735-.389l2.456 2.77.767-3.747c.2-.072.351-.13.452-.17l-.372-.928c-.148.06-.434.166-.836.304-.673.23-1.423.461-2.232.677-2.305.615-4.608.983-6.746.983-2.138 0-4.441-.368-6.746-.983A33.649 33.649 0 0 1 2.022.84a19.447 19.447 0 0 1-.836-.304l-.372.928c.082.033.197.077.343.13l.775 3.787 2.475-2.79c.359.09.718.176 1.076.255l1.711 4.33 2.293-3.731a21.313 21.313 0 0 0 2.367.037l2.27 3.696L15.777 3z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFestival1);
export default __webpack_public_path__ + "dist/media/icon-festival1.7e1ee4db3c8fa57e5ed2f2c5079556de.svg";
export { ForwardRef as ReactComponent };